<template>
  <div class="bankInfo">
    <mt-header :title="$t('bankInfo')">
      <router-link to slot="left">
        <mt-button @click="$router.back(-1)" icon="back">{{ $t('back') }}</mt-button>
      </router-link>
      <call-phone slot="right" />
    </mt-header>
    <div class="content">
      <div class="item">
        <img class="logo" src="../../../assets/logo.png">
        <div class="name">{{ $route.query.bank }}</div>
        <div class="number">****{{ $route.query.last4 }}</div>
      </div>
      <div class="info">
        <mt-cell :title="$t('deductionSequence')" is-link to="/mine/deductionSequence">
          <img slot="icon" src="../../../assets/deductionSequence.png" width="18" style="margin: 0px 10px">
        </mt-cell>
        <mt-cell :title="$t('checkTheBill')" is-link :to="`/mine/cardBills?id=${$route.query.id}`">
          <img slot="icon" src="../../../assets/checkTheBill.png" width="15" style="margin: 0px 11px 0px 12px">
        </mt-cell>
        <mt-cell :title="$t('unbind')" is-link @click.native="onUnind">
          <img slot="icon" src="../../../assets/unbind.png" width="17" style="margin: 0px 11px 0px 10px">
        </mt-cell>
      </div>
    </div>
    <mt-popup
      class="unbind"
      v-model="popupVisible"
    >
      <div class="box">
        <div class="title">{{ $t('warmTips') }}</div>
        <div class="content">
          {{ $t('unbindTips') }}
        </div>
        <div class="bottom">
          <mt-button type="primary" size="large" @click="popupVisible = false">{{
            $t("cancel")
          }}</mt-button>
          <mt-button type="primary" size="large" @click="onUnindClick">{{
            $t("confirm")
          }}</mt-button>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { unbindCard } from '../../../utils/api'
import callPhone from '@/components/callPhone.vue'
export default {
  name: 'BankInfo',
  components: {
    callPhone
  },
  data () {
    return {
      popupVisible: false,
    }
  },
  created() {
    
  },
  methods: {
    // 解绑
    async onUnind() {
      this.popupVisible = true
    },
    async onUnindClick() {
      this.$indicator.open({
        spinnerType: "fading-circle",
      });
      const formData = new FormData()
      formData.append('id', this.$route.query.id)
      await this.$axios({
        method: 'post',
        url: unbindCard,
        data: formData,
      })
        .then((e) => {
          if (e.status.code == "000") {
            this.$router.back(-1)
          } else {
            this.$toast(e.status.msg)
          }
        })
        .catch(() => {})
      this.$indicator.close();
    }
  }
}
</script>

<style lang="scss" scoped>
.bankInfo {
  > .content {
    padding: 0px 40px;
    .item {
      margin-top: 25px;
      height: 80px;
      border-radius: 10px;
      background: linear-gradient(0deg, #47B526 14.20898%, #82e863 100%);
      padding: 10px 15px;
      display: flex;
      font-size: 15px;
      color: #FFFFFF;
      font-weight: bold;
      line-height: 24px;
      .logo {
        height: 33px;
        margin-right: 10px;
      }
      .name {
        flex: 1;
      }
    }
    .info {
      margin: 18px 0px;
      /deep/ .mint-cell-wrapper {
        padding-left: 0px;
        padding-right: 0px;
        color: #393939;
        font-size: 15px;
      }
    }
  }
  .unbind {
    border-radius: 10px;
    overflow: hidden;
    .box {
      width: 260px;
      .title {
        text-align: center;
        border-bottom: 1px solid #E4E4E4;
        font-size: 13px;
        padding: 8px;
      }
      .content {
        font-size: 12px;
        padding: 20px 10px;
        text-align: center;
      }
      .bottom {
        border-top: 1px solid #E4E4E4;
        display: flex;
        .mint-button {
          height: 35px;
          background-color: white;
          color: #9B9B9B;
          font-size: 13px;
          border-radius: 0px;
          &:last-child {
            color: #209CE8;
            border-left: 1px solid #E4E4E4;
          }
        }
      }
    }
  }
}
</style>